import { Injectable } from '@angular/core'

import { IFlowReservation, vehiclesParameters } from '../shared/steps/step.model'
import { HttpClient } from '@angular/common/http'
import { ResourceService } from 'app/shared/resources/resource.service';
import { SalesChannelService } from 'app/shared/salesChannel/sales-channel.service';
import { LocalDate } from 'js-joda';
import { Observable } from 'rxjs';
import { toParamsObj } from 'app/shared/utils';
import { ICabinFaresWire, IWireLegSelections, IHybridResult } from './cabin-fares-wire.interfaces';
import { AgentIdService } from 'app/shared/agent-id.service';
import { EnvironmentService } from 'app/environment.service';

@Injectable()
export class CabinFaresWireService {

    constructor(private http: HttpClient, private resourceService: ResourceService, private salesChannelService: SalesChannelService,
        private agentIdService: AgentIdService, private environmentService: EnvironmentService) {

    }

    public getCabinFaresFlow(reservation: IFlowReservation, outboundDepartureDate: LocalDate, returnDepartureDate: LocalDate): Observable<ICabinFaresWire> {
        let params = {
            salesOwnerId: this.resourceService.getSalesOwner(),
            localeCode: this.resourceService.getLocale(),
            salesChannelCode: this.salesChannelService.getCode(),
            outboundRouteCode: reservation.outboundRouteCode,
            outboundDepartureDate: outboundDepartureDate,
            productCode: reservation.productCode,
            returnRouteCode: reservation.returnRouteCode,
            returnDepartureDate: returnDepartureDate,
            adults: reservation.adults,
            children: reservation.children,
            childAges: reservation.childrenAges,
            infants: reservation.infants,
            isAmendment: false,
            offer: reservation.offerCode,
            ...vehiclesParameters(reservation),
            agentGenericId: this.agentIdService.getAgentId()
        }

        return this.http.get<ICabinFaresWire>(`${this.environmentService.getOrchestrationUrl()}/cabin-fares-flow`, { params: toParamsObj(params) })
    }

    public postCabinFaresFlow(selections: IWireLegSelections): Observable<IHybridResult> {
        return (this.http.post(`${this.environmentService.getOrchestrationUrl()}/cabin-fares-flow`, selections) as Observable<IHybridResult>)
    }

}
